<template>
  <div
    class="h-50px leading-50px text-center font-[MiSans-Bold] font-bold !text-20px text-#4B5669 border-solid border-x-none border-t-none border-#E5E7EB border-b-1"
  >
    {{ AppName }}
  </div>
  <el-menu
    @select="handleSelect"
    :default-active="routeName"
    :collapse="menuCollapse"
    :style="{ height: `calc(100% - 50px)` }"
  >
    <MenuItem :routes="routes"> </MenuItem>
  </el-menu>
  <el-icon
    class="fixed bottom-12px z-99 cursor-pointer text-#7A8699 hover:bg-#F2F3F5"
    :style="{
      left: iconFixedLeft,
    }"
    :name="`icon-base-menu-${menuCollapse ? 'fold' : 'unfold'}`"
    @click="menuCollapse = !menuCollapse"
    size="16px"
  ></el-icon>
</template>

<script lang="ts" setup>
import useMenu from '@/hooks/useMenu'
import useTabs from '@/hooks/useTabs'
import { ChildrenRoutes } from '@/plugins/router'
import { useI18n } from 'vue-i18n'

const routes = computed(() => {
  return ChildrenRoutes
})
const router = useRouter()
const route = useRoute()
const { activeTabName } = useTabs()
const { menuCollapse, activeMenuName } = useMenu()
const scrollX = ref(0)
const iconFixedLeft = computed(() => {
  return menuCollapse.value
    ? `${-scrollX.value + 20}px`
    : `${-scrollX.value + 120}px`
})
const routeName = computed(() => route.name as string)
const { t } = useI18n()
const AppName = computed(() => {
  return t('productName')
})

const handleSelect = (index: string) => {
  activeTabName.value = index
  router.push({ name: index })
  activeMenuName.value = index
}

const handleScroll = () => {
  scrollX.value = window.scrollX
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style scoped lang="scss"></style>
